/**
 * Runtime config picked by the host the iframe is served from.
 * Both values are public (client_id is in shopify.app.erpclaw.toml which is
 * committed; Worker URL is intended to be reachable by end users).
 */

const WORKER_URL_BY_HOST: Record<string, string> = {
  "admin.shopify.erpclaw.ai": "https://shopify.erpclaw.ai",
  "admin-staging.shopify.erpclaw.ai": "https://shopify-staging.erpclaw.ai",
  "erpclaw-shopify-ui-staging.pages.dev": "https://shopify-staging.erpclaw.ai",
};

function pickWorkerUrl(host: string): string {
  if (host in WORKER_URL_BY_HOST) return WORKER_URL_BY_HOST[host]!;
  // Pages preview deployments come as <hash>.erpclaw-shopify-ui-staging.pages.dev
  if (host.endsWith(".erpclaw-shopify-ui-staging.pages.dev")) {
    return "https://shopify-staging.erpclaw.ai";
  }
  // Local dev fallback (vite on :5173 talks to wrangler on :8787)
  return "http://localhost:8787";
}

export const WORKER_URL =
  typeof window !== "undefined" ? pickWorkerUrl(window.location.host) : "";

/** Shopify App Bridge client_id (public identifier). */
export const SHOPIFY_API_KEY = "f2101ffe028c30971e55dcc2b3957686";

/** Pairing code lifetime on the Worker side, mirrored here for the countdown. */
export const PAIRING_CODE_TTL_SECONDS = 600;
